import { HttpBackend, HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { EnvironmentConfig, MedDataCommonModule, MedDataLayoutModule } from '@meddatacore/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { appConfig } from './config';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
export function createTranslateLoader(http: HttpBackend): any {
  return new MultiTranslateHttpLoader(http, [{ prefix: 'assets/i18n/queue/', suffix: '.json' }, { prefix: 'assets/i18n/', suffix: '.json' }]);
}
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    // NgxPermissionsModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpBackend],
      },
    }),
    MedDataCommonModule.forRoot({ env: appConfig.environment } as EnvironmentConfig),
    MedDataLayoutModule.forRoot(appConfig.routes),
    SharedModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
